import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
declare var $: any;
import * as _ from 'lodash';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { DataTableDirective } from 'angular-datatables';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { AlertComponent } from '../../alert/alert.component';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { Sh3Service } from 'src/app/services/sh3.service';


@Component({
  selector: 'app-sh3',
  templateUrl: './sh3.component.html',
  styleUrls: ['./sh3.component.css']
})
export class Sh3Component implements OnInit {

  public environmentSettings: any;

@ViewChildren(DataTableDirective)
dtElements: QueryList<DataTableDirective>;
dtOptionsOfMbp: DataTables.Settings = {};
sh3Form: FormGroup ;
totalForm: FormGroup ;
lockForm: FormGroup ;
valuationForm: FormGroup ;

sh3List : any[];
totalList : any[];
lockList : any[];
valuationList : any[];
restrictTabflag: boolean;
editParticularData: any;
editParticularId: any;
nameInterestedDirector: any[];
masterDirectorList: any[];
showchangeYes: boolean;
showchargesregistered: boolean;
addTotalBtn: boolean;
addLockBtn: boolean;
addValuationBtn: boolean;
numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

editSh3Data : any=[];
restrictTabFlag : false;
editSh3ID : any = [];
dateOfPassingBoardResolution : any;
dateOfSpecialResoltuion: any;
dateOfIssueOfSweat: any;
particularsOfConsideration: any;
theDateOfExpiryOfLockInPeriod: any;
dateOfJoiningOfEmployee: any;
dateOfPassingBoardResolutionModel: { month: number; day: number; year: number; };
dateOfSpecialResoltuionModel: { month: number; day: number; year: number; };
dateOfIssueOfSweatModel: { month: number; day: number; year: number; };
particularsOfConsiderationModel: { month: number; day: number; year: number; };
dateOfJoiningOfEmployeeModel: { month: number; day: number; year: number; };
theDateOfExpiryOfLockInPeriodModel: { month: number; day: number; year: number; };
allotmentNoList: any[];
disabledOnClick: boolean;

  constructor( private Sh3Service : Sh3Service, private activatedRoute : ActivatedRoute, private commonFunction : CommonFunction, 
    private directorMasterService: DirectorMasterService, private mgt1Service: Mgt1Service,
    private alert : AlertComponent, private router : Router, private customValidation: CustomValidation) { }

  ngOnInit() {

    
    this.sh3Form = new FormGroup({
      referenceToEntry: new FormControl('', [Validators.required]),
      statusOfAllotee: new FormControl('', [Validators.required]),
      dateOfPassingBoardResolution: new FormControl('', []),
      dateOfSpecialResoltuion: new FormControl('', []),
      nameOfAllotee: new FormControl('', []),
      nameOfTheInterestedDirector: new FormControl('', []),
      employeeName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      dateOfIssueOfSweat: new FormControl('', []),
      numberofsweatequitysharesissued: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      certificateNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      folioNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      faceValue: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,./&-]*$"), Validators.maxLength(20)]),
      priceAtWhichSharesAreIssued: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,./&-]*$"), Validators.maxLength(200)]),
      amountToBeTreatedAsPaidUp: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,./&-]*$"), Validators.maxLength(200)]),
    });

    this.totalForm = new FormGroup({
      
      considerationReceivedInCash: new FormControl('', [Validators.pattern("^[0-9 ,./&-]*$"), Validators.maxLength(200)]),
      particularsOfConsideration: new FormControl('', []),
      
    });
    this.lockForm = new FormGroup({
      lockInPeriod: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.]*$"), Validators.maxLength(200)]),
      theDateOfExpiryOfLockInPeriod: new FormControl('', []),
    });
    this.valuationForm = new FormGroup({
      fairValueObtained: new FormControl('', [Validators.pattern("^[0-9 ,./&-]*$"), Validators.maxLength(200)]),
      basisOfValuation: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      nameOfValuer: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,./&-]*$"), Validators.maxLength(200)]),
      dateOfJoiningOfEmployee: new FormControl('', []),
      remarks: new FormControl('', [Validators.maxLength(1000)]),
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
         this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getSh3ById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })

    this.getMasterDirector();
    this.getRegisterMgt1List();
  }

  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh3list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }

  getRegisterMgt1List() {
    this.allotmentNoList = [];
    
    this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
      for(let i=0; i< MgtList.data.length; i++){
       
        for(let j=0; j< MgtList.data[i].detailsOfHoldings.length; j++){
        

          if(MgtList.data[i].detailsOfHoldings[j].allotmentNo != ""){
            this.allotmentNoList.push({MGT1_id:MgtList.data[i].detailsOfHoldings[j]._id,
                                       allotmentNo:MgtList.data[i].detailsOfHoldings[j].allotmentNo});
            }
         
        }
    }
     
    });
  }

  sh3FormDetails(ev,value){
    // const selectEl = ev.target;
    const MGT1_id = ev.target.options[ev.target.selectedIndex].getAttribute('data-mgt1id');
    // console.log('%%%%%%%%%%%%%%',MGT1_id)
    this.sh3Form.controls.mgt1Id = MGT1_id;
  }

  getMasterDirector() {
    this.nameInterestedDirector = [];
    var filterDate = {
      FromDate: null,
      ToDate: null,
    }

    this.directorMasterService.getMasterDirector(filterDate)
    .subscribe(masterDirectorList => {
      this.masterDirectorList = masterDirectorList.directorList;
    });
  }


  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  } 

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
   
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  changeAllotteeType(value){
    if(value == 'Director')
    {
      // this.sh3Form.controls.employeeName.setValidators([]);
     
      this.sh3Form.controls.employeeName.setValidators([]);
      this.sh3Form.controls.employeeName.setValue('');
    
    }
    else{
      // this.sh3Form.controls.nameOfTheInterestedDirector.setValidators([]);
      this.sh3Form.controls.nameOfTheInterestedDirector.setValidators([]);
      this.sh3Form.controls.nameOfTheInterestedDirector.setValue('');
    }
    this.sh3Form.controls.nameOfTheInterestedDirector.updateValueAndValidity();
    this.sh3Form.controls.employeeName.updateValueAndValidity();
  }



  saveSh3(){
    this.disabledOnClick = true;
    var object = {
  
      referenceToEntry : this.sh3Form.controls.referenceToEntry.value,
      statusOfAllotee : this.sh3Form.controls.statusOfAllotee.value,
      dateOfPassingBoardResolution : this.setDate(this.sh3Form.controls.dateOfPassingBoardResolution.value) ,
      dateOfSpecialResoltuion : this.setDate(this.sh3Form.controls.dateOfSpecialResoltuion.value) ,
      nameOfAllotee :this.sh3Form.controls.nameOfAllotee.value ,
      nameOfTheInterestedDirector: this.sh3Form.controls.nameOfTheInterestedDirector.value,
      employeeName: this.sh3Form.controls.employeeName.value,
      dateOfIssueOfSweat : this.setDate(this.sh3Form.controls.dateOfIssueOfSweat.value) ,
      numberofsweatequitysharesissued : this.sh3Form.controls.numberofsweatequitysharesissued.value,
      certificateNo : this.sh3Form.controls.certificateNo.value ,
      folioNo : this.sh3Form.controls.folioNo.value ,
      faceValue : this.sh3Form.controls.faceValue.value ,
      priceAtWhichSharesAreIssued : this.sh3Form.controls.priceAtWhichSharesAreIssued.value ,
      amountToBeTreatedAsPaidUp :this.sh3Form.controls.amountToBeTreatedAsPaidUp.value ,
      mgt1Id:this.sh3Form.controls.mgt1Id
     
}

  this.Sh3Service.samplesh3Record(object).subscribe(response => {
    this.disabledOnClick = false;
    if (response.status == 0) {
      this.restrictTabflag = true;
      this.alert.successWithOk(response.message, 'sh-3/edit/' + response.data._id);
    } else {
      this.restrictTabflag = false;
    
      if(response.err_fields){
      this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
      }
      else{
          this.alert.error(response.message);
      }
    }
  })
}

saveTotal(){
  this.disabledOnClick = true;
  var total = {
     
     considerationReceivedInCash : this.totalForm.controls.considerationReceivedInCash.value,
     particularsOfConsideration : this.setDate(this.totalForm.controls.particularsOfConsideration.value) ,
     particularId: this.editParticularId

  }

  this.Sh3Service.updateTotalEmployeeDirector(total).subscribe(response => {
    this.disabledOnClick = false;
    if (response.status == 0) {
      this.alert.success(response.message);
      
    } else {
    
      if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
            this.alert.error(response.message);
        }
    }
  })

} 


saveLock(){
  this.disabledOnClick = true;
  var lockindetails = {
     
     lockInPeriod : this.lockForm.controls.lockInPeriod.value,
     theDateOfExpiryOfLockInPeriod : this.setDate(this.lockForm.controls.theDateOfExpiryOfLockInPeriod.value),
     particularId: this.editParticularId

  }
  this.Sh3Service.lockDetails(lockindetails).subscribe(response => {
    this.disabledOnClick = false;
    if (response.status == 0) {
      // this.alert.successWithOk(response.message, '/sh-3/edit/' + response.data._id);
      this.alert.success(response.message);
    } else {
     
      if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
            this.alert.error(response.message);
        }
    }
  })

}

saveValuation(){
  this.disabledOnClick = true;
  var valuationdetails = {
    
    fairValueObtained : this.valuationForm.controls.fairValueObtained.value ,
    basisOfValuation : this.valuationForm.controls.basisOfValuation.value ,
    nameOfValuer : this.valuationForm.controls.nameOfValuer.value ,
    dateOfJoiningOfEmployee : this.setDate(this.valuationForm.controls.dateOfJoiningOfEmployee.value),
    remarks : this.valuationForm.controls.remarks.value,
    particularId: this.editParticularId

  }
  this.Sh3Service.valuationDetails(valuationdetails).subscribe(response => {
    this.disabledOnClick = false;
    if (response.status == 0) {
      
      // this.alert.successWithOk(response.message, '/sh-3/edit/' + response.data._id);
      this.alert.success(response.message);
    } else {
      if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
            this.alert.error(response.message);
        }
    }
  })

}

getSh3ById(particularId) {
  this.Sh3Service.update(particularId).subscribe(response => {
    this.editParticularData = response.data[0];
    this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
      // this.Mgt1List.push(MgtList.data);
      MgtList.data.forEach(element => {
        element.detailsOfHoldings.forEach(item => {
          if(item._id == this.editParticularData.mgt1Id){
            this.sh3Form.controls.referenceToEntry.setValue(item.allotmentNo);
            return false
          }
        })
      })
    });

    // this.sh3Form.controls.referenceToEntry.setValue(this.editParticularData.referenceToEntry);
    this.sh3Form.controls.statusOfAllotee.setValue(this.editParticularData.statusOfAllotee);
    this.sh3Form.controls.dateOfPassingBoardResolution.setValue(this.editParticularData.dateOfPassingBoardResolution);
    this.sh3Form.controls.dateOfSpecialResoltuion.setValue(this.editParticularData.dateOfSpecialResoltuion);
    this.sh3Form.controls.nameOfAllotee.setValue(this.editParticularData.nameOfAllotee);
    this.sh3Form.controls.nameOfTheInterestedDirector.setValue(this.editParticularData.nameOfTheInterestedDirector);
    this.sh3Form.controls.employeeName.setValue(this.editParticularData.employeeName);
    this.sh3Form.controls.dateOfIssueOfSweat.setValue(this.editParticularData.dateOfIssueOfSweat);
    this.sh3Form.controls.numberofsweatequitysharesissued.setValue(this.editParticularData.numberofsweatequitysharesissued);
    this.sh3Form.controls.certificateNo.setValue(this.editParticularData.certificateNo);
    this.sh3Form.controls.folioNo.setValue(this.editParticularData.folioNo);
    this.sh3Form.controls.faceValue.setValue(this.editParticularData.faceValue);
    this.sh3Form.controls.priceAtWhichSharesAreIssued.setValue(this.editParticularData.priceAtWhichSharesAreIssued);
    this.sh3Form.controls.amountToBeTreatedAsPaidUp.setValue(this.editParticularData.amountToBeTreatedAsPaidUp);
    

    if (this.editParticularData.dateOfPassingBoardResolution != null) {
      let dt = new Date(this.setFormatDate(this.editParticularData.dateOfPassingBoardResolution));
      this.dateOfPassingBoardResolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (this.editParticularData.dateOfSpecialResoltuion != null) {
      let dt = new Date(this.setFormatDate(this.editParticularData.dateOfSpecialResoltuion));
      this.dateOfSpecialResoltuionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (this.editParticularData.dateOfIssueOfSweat != null) {
      let dt = new Date(this.setFormatDate(this.editParticularData.dateOfIssueOfSweat));
      this.dateOfIssueOfSweatModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }


    if (this.editParticularData.total) {
      this.addTotalBtn = false;
       this.totalForm.controls.considerationReceivedInCash.setValue(this.editParticularData.total.considerationReceivedInCash);
       this.totalForm.controls.particularsOfConsideration.setValue(this.editParticularData.total.particularsOfConsideration);
      
      if (this.editParticularData.total.particularsOfConsideration != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.total.particularsOfConsideration));
        this.particularsOfConsiderationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
     

    } else {
      this.addTotalBtn = true;
    }


    if (this.editParticularData.lockindetails) {
      this.addLockBtn = false;
 
       this.lockForm.controls.lockInPeriod.setValue(this.editParticularData.lockindetails.lockInPeriod);
       this.lockForm.controls.theDateOfExpiryOfLockInPeriod.setValue(this.editParticularData.lockindetails.theDateOfExpiryOfLockInPeriod);
      
      if (this.editParticularData.lockindetails.theDateOfExpiryOfLockInPeriod != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.lockindetails.theDateOfExpiryOfLockInPeriod));
        this.theDateOfExpiryOfLockInPeriodModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
     

    } else {
      this.addLockBtn = true;
    }


    if (this.editParticularData.valuationdetails) {
      this.addValuationBtn = false;
     
       this.valuationForm.controls.fairValueObtained.setValue(this.editParticularData.valuationdetails.fairValueObtained);
       this.valuationForm.controls.basisOfValuation.setValue(this.editParticularData.valuationdetails.basisOfValuation);
       this.valuationForm.controls.nameOfValuer.setValue(this.editParticularData.valuationdetails.nameOfValuer);
       this.valuationForm.controls.dateOfJoiningOfEmployee.setValue(this.editParticularData.valuationdetails.dateOfJoiningOfEmployee);
       this.valuationForm.controls.remarks.setValue(this.editParticularData.valuationdetails.remarks);
      
      
      if (this.editParticularData.valuationdetails.dateOfJoiningOfEmployee != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.valuationdetails.dateOfJoiningOfEmployee));
        this.dateOfJoiningOfEmployeeModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
     

    } else {
      this.addValuationBtn = true;
    }



  })
}

updateSh3() {
  this.disabledOnClick = true;
  var object = {
      referenceToEntry : this.sh3Form.controls.referenceToEntry.value,
      statusOfAllotee : this.sh3Form.controls.statusOfAllotee.value,
      dateOfPassingBoardResolution : this.setDate(this.dateOfPassingBoardResolutionModel),
      dateOfSpecialResoltuion : this.setDate(this.dateOfSpecialResoltuionModel),
      nameOfAllotee :this.sh3Form.controls.nameOfAllotee.value,
      nameOfTheInterestedDirector: this.sh3Form.controls.nameOfTheInterestedDirector.value,
      employeeName: this.sh3Form.controls.employeeName.value,
      dateOfIssueOfSweat : this.setDate(this.dateOfIssueOfSweatModel),
      numberofsweatequitysharesissued : this.sh3Form.controls.numberofsweatequitysharesissued.value,
      certificateNo : this.sh3Form.controls.certificateNo.value,
      folioNo : this.sh3Form.controls.folioNo.value,
      faceValue : this.sh3Form.controls.faceValue.value,
      priceAtWhichSharesAreIssued : this.sh3Form.controls.priceAtWhichSharesAreIssued.value,
      amountToBeTreatedAsPaidUp :this.sh3Form.controls.amountToBeTreatedAsPaidUp.value,
      mgt1Id:this.sh3Form.controls.mgt1Id

}
  
  this.Sh3Service.sh3Update(object, this.editParticularId ).subscribe(response => {
    this.disabledOnClick = false;
    if (response.status == 0) {
      this.alert.success(response.message);
    } else {
      if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
            this.alert.error(response.message);
        }
    }

  })
}

generateOutput() {
  var object = {
    id: this.editParticularId,
    fromDate:null,
    toDate: null
  }
  this.Sh3Service.generateSh3Document(object).subscribe(response => {
    if (response.status == 0) {
      this.alert.success(response.message);
      var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
    } else {
      this.alert.error(response.message);
    }
  })
}

downloadDocument(id) {
  this.Sh3Service.downloadSh3File(id, 'Single');
}
downloadPdfDocument(id) {
  this.Sh3Service.downloadSh3PdfFile(id, 'Single');
}

}
